export function scoreFromError(error, maxError) {
  const t = Math.min(1, Math.max(0, error / maxError))
  return Math.max(0, Math.min(100, 100 * Math.pow(1 - t, 1.35)))
}

/** Average of round scores, still 0–100 */
export function averageScore(scores) {
  if (!scores.length) return 0
  return scores.reduce((a, b) => a + b, 0) / scores.length
}

export function formatScore(n) {
  return n.toFixed(2)
}

export function sumScores(scores) {
  return scores.reduce((a, b) => a + b, 0)
}
